<template>
	<div class="resetpasswordemail">
		<!-- <div class="share" v-loading="loading" element-loading-text="正在发送邮件，请稍等！"  element-loading-spinner="el-icon-loading"><p>正在发送邮件，请稍等！</p></div> -->
		<el-container>
			<div class="main">
				<div class="pos_icon">
					<div class="icon"><img src="../../static/img/login2/registeremail1.png" alt=""></div>
					<el-input
					:placeholder="$t('forgetpassword.EnterEmail')"
					v-model="email"
					clearable
					class="mailbox"	
					maxlength="32"
					@change="emailVerification"		
					>
					</el-input>
				</div>
				
				<p class="danger" v-show="flag4">{{$t('forgetpassword.FalseEmail')}}</p>
				<p class="danger" v-show="flag7">{{$t('forgetpassword.NoEmail')}}</p>
				<p class="danger" v-show="flag11">{{$t('forgetpassword.NotEmail')}}</p>

				<div class="yanzheng pos_icon">
					<div class="icon icon1"><img src="../../static/img/login2/registerPhone3.png" alt=""></div>
					<el-input :placeholder="$t('login.entercode')" v-model="input4" clearable class="">
					</el-input>
					<el-button class="get" @click="send" ref='banner'>{{msg}}</el-button>
				</div>
				<p class="danger" v-show="flag7">{{$t('forgetpassword.NotCode')}}</p>
				<p class="danger" v-show="flag8">{{$t('forgetpassword.NoMatch')}}</p>

				<router-link to="/login" class="had"><p>{{$t('forgetpassword.HadAccount')}}</p></router-link>
				<el-button class="sub" @click="sub"  style="color: #FFFFFF;">{{$t('forgetpassword.next')}}</el-button>
				<div class="privacy">
					{{$t('login.agree')}}<router-link to="/privacyStatement">{{$t('login.privacyStatement')}}</router-link>
				</div>
			</div>
		</el-container>
	</div>
</template>

<script>
import { Verification,sendreset } from "../api/index.js";
import { registerSendEmail } from "../api/index.js";
import { userLogin } from "../api/index.js";
import { email } from "../api/index.js";
import { sendCode2,checkCode2, areaCode } from "../apiNew/index.js";
import store from "../store/store.js";
import Qs from "qs";
import axios from "axios";
export default{
	name:'registeremail',
	data(){
		return{
			flag4:false,
			flag7:false,
			flag8:false,
			flag11:false,
			loading:false,
			email:'',
			password:"",
			repassword:"",
			input4:'',
			forbidden:'',
			msg:this.$t('forgetpassword.verify'),
			cmsg:this.$t('forgetpassword.verify'),
			rmsg:this.$t('forgetpassword.resend')
		}
	},
  	methods: {
  		emailVerification() {
	      	// let reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
	      	// if (reg.test(this.email)) {
	        // 	this.flag4 = false;
			// 	this.flag11 = false;
	      	// } else {
			// 	if(this.email==0){
			// 		this.flag4 = false;
			// 		this.flag11=true;
			// 	}else{
			// 		this.flag4 = true;
			// 		this.flag11=false;
			// 	}
	        	
			  // }
			let params=Qs.stringify({
				account: this.email
			})
			email(params)
			.then(res=>{
				console.log("验证用户是否存在：[true:存在]",res)
				if(res.data.data==true){
					this.flag7=false;
				}else{
					this.flag7=true;
				}
			})
			.catch(error=>{
				console.log(error)
			})
    	},
		sub(){
			let params = Qs.stringify({
				username: this.email,
				vaildCode: this.input4
			})
			checkCode2(params)
			.then(res=>{
				console.log("验证码是否正确", res)
				if(res.data.header.status==1000){
					this.$router.push({
						path:'/resetpassword',
						query:{
							phone:this.email,
							smsCode:'isEmail'
						}
					})
				}
			})
			.catch(err=>{
				console.log(err)
			})
			// if(this.email!=0){
			// 	if(this.flag4==false&&this.flag11==false){
			// 		var params=Qs.stringify({
			// 			account: this.email
			// 		});
			// 		email(params)//验证用户是否存在
			// 		.then(res=>{
			// 			console.log(res)
			// 			if(res.data.data==true){
			// 				this.$message({
			// 					message: this.$t('prompt.sending'),
			// 					type: 'success'
			// 				});
			// 				this.loading=true;
			// 				this.flag7=false
			// 				var params = Qs.stringify({
			// 					username: this.email
			// 				});
			// 				sendreset(params)
			// 				.then(res=>{
							
			// 					this.$router.push({path:'/resetemailproving',query:{
			// 						email:this.email
			// 					}})
			// 					console.log(res)
			// 				})
			// 				.catch(error=>{
			// 					console.log(error)
			// 				})
			// 			}else{
			// 				this.flag7=true
			// 			}
							
			// 		})
			// 		.catch(error=>{
			// 			console.log(error)
			// 		})
			// 	}
			// }else{
			// 	this.flag11=true;
			// }
		},
		send(){
			console.log("666666666666666666")
			let params= Qs.stringify({
				username: this.email,
				lang:localStorage.getItem("locale")
			})
			sendCode2(params)
			.then(res=>{
				console.log("发送验证码：",res)
			})
			.catch(err=>{
				console.log(err)
			})
		}
  	}
  }
</script>
<style>
/* body{
	position: relative;
}
.share{
	position: absolute;
	z-index: 5;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	color: green;
	text-align: center;
	display: flex;
	align-items:center;
	justify-content: center;
}
.share p{
	background: #7eeba5;
	font-family: '宋体';
	width: 90%;
	text-align: center;
	color: #ffffff;
	line-height: 3.2rem;
	border-radius: 0.5rem;
	font-size: 1rem;
} */
</style>
<style>
.el-message {
  min-width: 85%;
}
.resetpasswordemail .el-input input{
	border: 0;
	border-bottom: 1px solid #cccccc;
	border-radius: 0;
	box-sizing: border-box;
	padding-left: 2.5rem;
}
</style>

<style scoped>
	.resetpasswordemail{
		margin-top: 30px;
	}
	.main{
		width: 100%;
		padding: 0 0px;
	}
	.pos_icon{
		position: relative;
		width: 100%;
		height: 2.6rem;
		line-height: 2.6rem;
		margin-top: 20px;
	}
	.icon{
		position: absolute;
		z-index: 99;
		width: 2rem;
		height: 1.5rem;
		line-height: 1.5rem;
		border-right: 1px solid #cccccc;
		top: 0.5rem;
	}
	.icon img{
		width: 1rem;
		vertical-align: middle;
	}

	.get {
		width: 6rem;
		position: absolute;
		z-index: 999;
		top: 0;
		right: 0;
		padding: 0;
		height: 2rem;
		line-height: 2rem;
		color: #7dc3f2;
		box-sizing: border-box;
		border: 1px solid #7dc3f2;
		border-radius: 8px;	
	}
	.get.el-button.is-disabled{
		color: #c0c4cc;
		background-color: #ffffff;
	}
	.yanzheng {
		width: 100%;
		position: relative;
	}

	.sub{
		width: 72%;
		margin-left: 14%;
		font-size: 1rem;
		height: 2.6rem;
		line-height: 2.6rem;
		color: rgb(255,255,255);
		margin-top: 30px;
		border-radius: 1.3rem;
		background-image: linear-gradient(to right , #65d3e8, #7dc3f2);
		border: 0;
		padding: 0 0;
	}
	.danger{
		font-size: 0.625rem;
		margin-top: 5px;
		color: red;
	}
	.had{
		display: block;
		width: 90%;
		margin: 0 auto;
		color: #7dc3f2;
		font-size: 0.5rem;
		text-align: right;
		margin-top: 20px;
	}
	.privacy{
		width: 90%;
		margin: 0 auto;
		text-align: right;
		font-size: 0.6rem;
		color: #65d3e8;
		letter-spacing: 2px;
		margin-top: 20px;
	}
	.privacy a{
		color: #f17f10;
		border-bottom: 1px solid#f17f10;
	}
</style>


// WEBPACK FOOTER //
// src/components/resetpasswordemail.vue